<template>
  <div class="faqs">
    <h1 class="text-orange">
      {{
        selectedMethod == "delivery"
          ? delivery.title
          : selectedMethod == "takeaway"
          ? takeaway.title
          : "FAQs"
      }}
    </h1>
    <div class="method-switch">
      <button
        :class="selectedMethod == 'delivery' ? 'btn' : 'btn--clear'"
        @click="selectedMethod = 'delivery'"
        class="uppercase w-full"
      >
        entrega
      </button>
      <button
        :class="selectedMethod == 'takeaway' ? 'btn' : 'btn--clear'"
        @click="selectedMethod = 'takeaway'"
        class="uppercase w-full"
      >
        levantar na loja
      </button>
    </div>

    <div v-if="selectedMethod == 'delivery'" class="mt-5">
      <accordion v-for="faq in delivery.content" :key="faq.title + 'delivery'">
        <accordion-item :htmlContent="faq.html" :isFaqs="true" class="py-4">
          <!-- This slot will handle the title/header of the accordion and is the part you click on -->
          <template slot="accordion-trigger"
            ><h5>{{ faq.section }}</h5>
          </template>
        </accordion-item>
      </accordion>
    </div>
    <div v-if="selectedMethod == 'takeaway'" class="mt-5">
      <accordion v-for="faq in takeaway.content" :key="faq.title + 'takeaway'">
        <accordion-item :htmlContent="faq.html" :isFaqs="true" class="py-4">
          <!-- This slot will handle the title/header of the accordion and is the part you click on -->
          <template slot="accordion-trigger"
            ><h5>{{ faq.section }}</h5>
          </template>
        </accordion-item>
      </accordion>
    </div>
  </div>
</template>

<script>
import {
  VsaList,
  VsaItem,
  VsaHeading,
  VsaContent,
  VsaIcon,
} from "vue-simple-accordion";

import Accordion from "./../accordion";
import AccordionItem from "./../accordion-item";
export default {
  components: {
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent,
    VsaIcon,
    Accordion,
    AccordionItem,
  },
  props: {
    takeaway: {
      required: true,
    },
    delivery: {
      required: true,
    },
  },
  data() {
    return {
      selectedMethod: "delivery",
      expanded: true,
      exampleDeliveryContent: [
        { title: "pergunta entrega 1", content: "resposta entrega 1" },
        { title: "pergunta entrega 2", content: "resposta entrega 2" },
        { title: "pergunta entrega 3", content: "resposta entrega 3" },
        { title: "pergunta entrega 4", content: "resposta entrega 4" },
      ],
      exampleTakeawayContent: [
        { title: "pergunta em loja 1", content: "resposta em loja 1" },
        { title: "pergunta em loja 2", content: "resposta em loja 2" },
        { title: "pergunta em loja 3", content: "resposta em loja 3" },
        { title: "pergunta em loja 4", content: "resposta em loja 4" },
      ],
    };
  },
};
</script>